
import { ProjectManager } from '@/models';
import { Component, Vue, VModel, Prop } from 'vue-property-decorator';
import Avatar from '@/components/common/avatar/Avatar.vue';

const headers = [
  { text: 'Avatar', value: 'avatarUrl' },
  { text: 'Email', value: 'user.email' },
  { text: 'Name', value: 'user.fullName' },
  { text: 'KMS ID', value: 'user.code' },
  { text: 'Status', value: 'status' }
];
@Component({
  components: {
    Avatar
  }
})
export default class ManagerListPopup extends Vue {
  @VModel()
  dialog!: boolean;

  @Prop({ type: Array, required: true })
  managers!: ProjectManager[];

  headers = headers;
}
